module.exports = "<div class=\"description\">Target Price</div>\n<div class=\"price\">{{ctrl.targetPrice$ | async : this}}</div>";